const inscriptions = new Map();

class DulinPersonalization extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.field = this.querySelector('[data-personalization-input]');
    if (!this.field) return;
    this.key = this.dataset.productId;
    if (inscriptions.has(this.key)) this.field.value = inscriptions.get(this.key);
    const options = { signal: this.controller.signal };
    this.field.addEventListener('input', () => this.sync(), options);
    this.sync(false);
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  sync(propagate = true) {
    const value = this.field.value;
    const filled = value.trim().length > 0;
    inscriptions.set(this.key, value);
    if (filled) this.field.name = 'properties[Personnalisation]';
    else this.field.removeAttribute('name');
    if (propagate) {
      document.querySelectorAll('dulin-personalization').forEach(other => {
        if (other !== this && other.dataset.productId === this.key && other.field) {
          other.field.value = value;
          other.sync(false);
        }
      });
    }
  }
}

if (!customElements.get('dulin-personalization')) {
  customElements.define('dulin-personalization', DulinPersonalization);
}

